import AOS from 'aos';


AOS.init();
// window.addEventListener('load', AOS.refresh)
// document.addEventListener('DOMContentLoaded', function (){
//     console.log("FROM AOS file")
//     AOS.refresh()
// } )


document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() { AOS.refresh(); }, 500);
});